import React from 'react';
import '../less/main.less';
import DOMPurify from 'utils/sanitize';
import { ReactSVG } from 'react-svg';

export default function template() {
  const { headText, text, title, img, middleText, btnLink, btnText, titleTag = 'h2' } = this.props;

  const Tag = titleTag;

  return (
    <div className="info-new">
      <div className="container">
        {headText && <div className="info-new__head info-new-other-text" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n(headText))}}></div>}
        {title && <Tag className="info-new__title">{this.l10n(title)}</Tag>}
        {middleText && <div className="info-new__middle info-new-other-text" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n(middleText))}}></div>}
        <div className={`info-new__body ${img ? 'with-img' : ''}`}>
          {img && <ReactSVG src={img} className="info-new__image" aria-hidden="true"/>}
          <div className="info-new__text text-info-new" dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(this.l10n(text), {
              ADD_ATTR: ['target']
            }),
          }}></div>
          {btnText && btnLink && (
            <a className="info-new__btn" href={btnLink} target="_blank" rel="noopener noreferrer" aria-label={`${this.l10n(btnText)} (${this.l10n('OPENS_IN_NEW_TAB')})`}>{this.l10n(btnText)}</a>
          )} 
        </div>
      </div>
    </div>
  );
}

